import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaAuthGuard } from '@okta/okta-angular';
import { CallbackComponent } from './callback/callback.component';
import { ApplicationComponent } from './home/application/application.component';
import { HistoryComponent } from './home/history/history.component';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './home/profile/profile.component';
import { SecurityComponent } from './home/security/security.component';
import { ForgotPasswordSubmitComponent } from './user/forgot-password-submit/forgot-password-submit.component';
import { ForgotPasswordValidateComponent } from './user/forgot-password-validate/forgot-password-validate.component';
import { ForgotPasswordComponent } from './user/forgot-password/forgot-password.component';
import { LogoutComponent } from './user/logout/logout.component';
import { PortalLoginComponent } from './user/portallogin/portallogin.component';
import { RegisterValidateComponent } from './user/register-validate/register-validate.component';
import { RegisterComponent } from './user/register/register.component';
import { VerificationComponent } from './verification/verification.component';
import { ForgotUsernameSubmitComponent } from './user/components/forgot-username-submit/forgot-username-submit.component';
import { ForgotUsernameComponent } from './user/components/forgot-username/forgot-username.component';
import { LoginValidateComponent } from './user/login-validate/login-validate.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    // canActivate: [AuthGuard.annoymousTo('/portallogin')],
    // canActivateChild: [AuthGuard.annoymousTo('/portallogin')],
    canActivate: [OktaAuthGuard],
    children: [
      {
        path: '',
        component: ApplicationComponent,
      },
      {
        path: 'profile',
        component: ProfileComponent,
      },
      {
        path: 'security',
        component: SecurityComponent,
      },
      {
        path: 'history',
        component: HistoryComponent,
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
    ],
  },
  {
    path: 'user',
    component: HomeComponent,
    // canActivate: [AuthGuard.annoymousTo('/portallogin')],
    // canActivateChild: [AuthGuard.annoymousTo('/portallogin')],
    canActivate: [OktaAuthGuard],
    children: [
      // {
      //     path: 'settings',
      //     component: SettingsComponent,
      // },
    ],
  },
  // {
  //     path: 'login',
  //     component: LoginComponent,
  //     // canActivate: [AuthGuard.userTo('/home')]
  // },
  {
    path: 'portallogin',
    component: PortalLoginComponent,
    // canActivate: [AuthGuard.userTo('/home')]
    canActivate: [OktaAuthGuard],
  },
  // {
  //     path: 'portallogin/callback',
  //     component: PortalLoginCallbackComponent,
  //     // canActivate: [AuthGuard.userTo('/home')]
  //     canActivate: [ OktaAuthGuard ],
  // },
  // {
  //     path: 'loginc',
  //     component: LoginComponent,
  //     // canActivate: [AuthGuard.userTo('/home')]
  //     canActivate: [ OktaAuthGuard ],
  // },
  {
      path: 'login-validate',
      component: LoginValidateComponent,
  },
  {
    path: 'register-validate',
    component: RegisterValidateComponent,
    // canActivate: [AuthGuard.userTo('/home')]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    // canActivate: [AuthGuard.userTo('/home')]
  },
  {
    path: 'forgot-password-validate',
    component: ForgotPasswordValidateComponent,
  },
  {
    path: 'forgot-password-reset',
    component: ForgotPasswordSubmitComponent,
  },
  {
    path: 'forgot-username',
    component: ForgotUsernameComponent,
    // canActivate: [AuthGuard.userTo('/home')]
  },
  {
    path: 'forgot-username/confirm',
    component: ForgotUsernameSubmitComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
    // canActivate: [AuthGuard.userTo('/home')]
  },
  {
    path: 'register-iamsmart',
    component: RegisterComponent,
    // canActivate: [AuthGuard.userTo('/home')]
  },
  {
    path: 'verification',
    component: VerificationComponent,
  },
  {
    path: 'login/callback',
    // component: LoginCallbackComponent,
    component: CallbackComponent,
  },
  // {
  //     path: 'oauth2/v1/authorize',
  //     component: LoginComponent,
  // },
  // {
  //     path: 'oauth2/v1/authorize/:app',
  //     component: LoginComponent,
  // },
  // {
  //     path: 'register',
  //     component: RegisterComponent,
  //     canActivate: [AuthGuard.userTo('/home')]
  // },
  {
    path: 'logout',
    component: LogoutComponent,
    // canActivate: [AuthGuard.annoymousTo('/')]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/portallogin',
    // component: MainComponent,
    // canActivate: [
    //     AuthGuard.annoymousTo('/portallogin'),
    //     // AuthGuard.userTo('/home')
    //     AuthGuard.userTo('/portallogin')
    // ]
  },
  { path: '**', redirectTo: '/portallogin' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
